/**
 * Product group picker — switches the PDP to another colorway product.
 */
export class ProductGroupPicker extends HTMLElement {
  connectedCallback() {
    this.onProductSwitchClick = this.onProductSwitchClick.bind(this);

    this.querySelectorAll('button.product-group-picker__swatch').forEach((el) => {
      el.addEventListener('click', this.onProductSwitchClick);
    });
  }

  disconnectedCallback() {
    this.querySelectorAll('button.product-group-picker__swatch').forEach((el) => {
      el.removeEventListener('click', this.onProductSwitchClick);
    });
  }

  get productInfo() {
    return this.closest('product-info');
  }

  onProductSwitchClick(event) {
    const control = event.currentTarget;
    const productUrl = control.dataset.productUrl;
    const productId = control.dataset.productId;
    if (!productUrl) return;
    if (productId && productId === this.dataset.productId) return;

    this.productInfo?.switchToProduct?.(productUrl);
  }
}

if (!customElements.get('product-group-picker')) {
  customElements.define('product-group-picker', ProductGroupPicker);
}
